import { useLingui } from '@lingui/react';
import { Button } from '@warp-ds/react';
import { useState } from 'react';
import { t } from '../../../locales/texts';
import usePulse from '../../hooks/usePulse';
import { useSidebarContext } from '../../state/SidebarContext';

const PaymentSection = () => {
    const { uiText, finnkode, isOwnAd, urls } = useSidebarContext();
    const { trackCreateOfferClick } = usePulse();
    const { i18n } = useLingui();

    const { actions } = uiText.sections.sidebar.optedIn;
    const buyNow = actions.initTransactionBuyNow?.text;

    const [ownAdErrosMsg, setOwnAdErrorMsg] = useState(false);

    const handleClick = (buyNowSelected: boolean) => {
        if (isOwnAd) {
            setOwnAdErrorMsg(true);
        } else {
            trackCreateOfferClick(buyNowSelected);

            // Config URL for make-offer can have adId either as path param or query param
            // Gotta have some logic around that.
            const getMakeOfferUrl = () => {
                const baseUrl = `${urls.internal.makeOffer}${finnkode}`;

                if (baseUrl.includes('?')) {
                    return `${urls.internal.makeOffer}${finnkode}&buyNow=${buyNowSelected}`;
                }

                return `${urls.internal.makeOffer}${finnkode}?buyNow=${buyNowSelected}`;
            };

            window.location.href = getMakeOfferUrl();
        }
    };

    // When the Ad has Buy Now button, the bid button should be secondary
    const bidButtonType = {
        primary: !buyNow,
        secondary: buyNow,
    };

    return (
        <div className="mb-24">
            <div data-decodedAdId={finnkode}></div>
            <div className="flex flex-col gap-12">
                {buyNow && (
                    <Button
                        className="w-full !max-w-full"
                        primary
                        onClick={() => handleClick(true)}
                    >
                        {buyNow}
                    </Button>
                )}
                <Button
                    className="w-full !max-w-full"
                    onClick={() => handleClick(false)}
                    {...bidButtonType}
                >
                    {actions.initTransaction.text}
                </Button>
            </div>
            {ownAdErrosMsg && (
                <p
                    className="s-text-negative text-center my-4 text-xs"
                    data-testid="validation-cannot-buy-own-item"
                >
                    {i18n._(t.payment.errorMessage)}
                </p>
            )}
        </div>
    );
};

export default PaymentSection;
